/* eslint-disable import/no-dynamic-require */

import {
    createStore, applyMiddleware, combineReducers, compose,
} from 'redux';
import thunk from 'redux-thunk';
import {
    setLocale, syncTranslationWithStore, I18n, i18nReducer, loadTranslations,
} from 'react-redux-i18n';
import {
    accountSettingsReducer, activePartnerName, nextInsuranceTerms, liliBankingTerms, lendioTerms
} from '@redux/reducers/accountSettingsReducer';
import { alreadyLoadedReducer } from '@redux/reducers/alreadyLoadedReducer';
import {
    cs_cz, en_cz, de_ch, en_ch, en_us, fr_ca, en_ca, hu_hu, en_hu, pl_pl, en_pl, en_si, sl_si, sv_se, en_se, da_dk, en_dk, fi_fi, en_fi, nn_no, en_no
} from '@root/public/localization';
import { IState } from '@customTypes/ItemTypes';
import { getLanguageCode, getLanguageCountryCode } from '@helpers/languages';
import {
    isMobile,
    isScreenWidthUnder600Pixel,
    isScreenWidthUnder768Pixel,
    isLoading,
    isError,
    hasNavigate,
    profileReducer, companyReducer, entilementsReducer,
    serviceIsDown, FreemiumProdDaysLeftReducer, dunsApplicationReducer, dunsInfoReducer,
    dunsSignupEmailReducer, companyInfoIsOpenedReducer, selectedCompanyInfoReducer,
    notificationReducer,
    dunsApplicationProgressReducer,
    applicationStateReducer,
} from './reducers';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(
    applyMiddleware(thunk),
);
const hasNavigateInitialValue = {
    deepLinkUrl: '',
    isNavigate: false,
    productName: ''
};
export const initialState:IState = {
    i18n: null,
    isScreenWidthUnder600Pixel: window.innerWidth <= 600,
    isScreenWidthUnder768Pixel: window.innerWidth <= 767,
    isMobile: window.innerWidth <= 1023,
    isFullPageLoading: false,
    isError: false,
    hasNavigate: hasNavigateInitialValue,
    profileDetails: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        countryCode: getLanguageCountryCode(),
        accountSettingsSSOLink: '',
        email: '',
        hasSubscription: false,
        hasDashboard: false,
        languagePreference: getLanguageCode(),
        product_subscriptions: [],
        street: '',
        city: '',
        state: '',
        postalCode: '',
        company_name: '',
        title_code: '',
        idaasUUID: '',
        userName: '',
        address1: '',
        address2: '',
        isDnbUser: false
    },
    companyInfo: [],
    entitlements: {
        companyInfo: [],
        credibilityEntitlements: [],
        pla: {
            accepted_tos: '',
            pla_content: undefined
        },
        vboEntitlements: []
    },
    serviceIsDown: false,
    accountSettings: {
        magento: false,
        eb_dashboard: false,
        customer_portal: false

    },
    alreadyLoaded: false,
    allFreemiumProdSubData: [],
    dunsApplication: {},
    activePartnerName: '',
    nextInsuranceTerms: [],
    liliBankingTerms: [],
    lendioTerms: [],
    dunsApplicationProgress: {},
    notificationDetails: {
        notifications: []
    },
    applicationState: {
        isDunsSelected: false,
        isAllProductsVBO: false,
        isCompanyDropDownOnlyAvailable: false,
        isCompanyDropDownWithOutAnyVBOProducts: false,
        deepLinkUrl: '',
    }
};

export const rootReducer = combineReducers({
    i18n: i18nReducer,
    isMobile,
    isScreenWidthUnder600Pixel,
    isScreenWidthUnder768Pixel,
    isFullPageLoading: isLoading,
    isError,
    hasNavigate,
    serviceIsDown,
    profileDetails: profileReducer,
    companyInfo: companyReducer,
    entitlements: entilementsReducer,
    accountSettings: accountSettingsReducer,
    alreadyLoaded: alreadyLoadedReducer,
    allFreemiumProdSubData: FreemiumProdDaysLeftReducer,
    dunsApplication: dunsApplicationReducer,
    dunsInfo: dunsInfoReducer,
    dunsSignupEmail: dunsSignupEmailReducer,
    companyInfoIsOpenedReducer,
    selectedCompanyInfo: selectedCompanyInfoReducer,
    activePartnerName,
    nextInsuranceTerms,
    liliBankingTerms,
    lendioTerms,
    dunsApplicationProgress: dunsApplicationProgressReducer,
    notificationDetails: notificationReducer,
    applicationState: applicationStateReducer
});

export type AppState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer, initialState, enhancer);
syncTranslationWithStore(store);
// @ts-ignore
I18n.setHandleMissingTranslation(() => '');

const langKey = getLanguageCode();

const transObj = {
    'cs-cz': cs_cz.default,
    'en-cz': en_cz.default,
    'en-ch': en_ch.default,
    'de-ch': de_ch.default,
    'en-us': en_us.default,
    'en-gb': en_us.default,
    'en-ie': en_us.default,
    'fr-ca': fr_ca.default,
    'en-ca': en_ca.default,
    'hu-hu': hu_hu.default,
    'en-hu': en_hu.default,
    'pl-pl': pl_pl.default,
    'en-pl': en_pl.default,
    'en-si': en_si.default,
    'sl-si': sl_si.default,
    'sv-se': sv_se.default,
    'en-se': en_se.default,
    'da-dk': da_dk.default,
    'en-dk': en_dk.default,
    'nn-no': nn_no.default,
    'en-no': en_no.default,
    'fi-fi': fi_fi.default,
    'en-fi': en_fi.default,
};
store.dispatch(loadTranslations(transObj));
store.dispatch(setLocale(langKey));

export default store;
